import { OPTION_COLORS, AGE_SEGMENTS_ORDER } from './constants';

export const OPTION_COLORS_DARK = ['#2563eb', '#16a34a', '#d97706', '#dc2626', '#7c3aed', '#db2777', '#0891b2', '#65a30d'];
export const SEX_COLORS = { 'Home': '#3b82f6', 'Dona': '#ec4899', 'Desconegut': '#94a3b8' };

// Normalize alternative segment names to the canonical form used in i18n keys
const SEGMENT_NORMALIZE = {
  'menys de 20': 'Menors de 20',
  'menors de 20': 'Menors de 20',
  'mes de 79': 'Majors de 79',
  'majors de 79': 'Majors de 79',
};

// Translate age segment names from Catalan backend data to current language
export function translateSegment(t, segmentName) {
  if (!segmentName) return segmentName;
  const cleaned = segmentName.replace(/ anys$/i, '');
  const normalized = SEGMENT_NORMALIZE[cleaned.toLowerCase()] || cleaned;
  return t(`ageSegments.${normalized}`, cleaned);
}

// Translate sex labels from Catalan backend data to current language
export function translateSex(t, sex) {
  if (!sex) return sex;
  return t(`sexLabels.${sex}`, sex);
}

export function getOptionTitle(option) {
  return typeof option === 'string' ? option : option.title;
}

export function getOptionsArray(consulta) {
  return (consulta?.options || []).map(opt => getOptionTitle(opt));
}

export function getTotalOptionsVoted(results) {
  if (!results?.results) return 0;
  return Object.values(results.results).reduce((sum, count) => sum + count, 0);
}

export function getChartData(results, consulta, optionColorMap) {
  if (!results?.results || !consulta?.options) return [];
  const totalOptionsVoted = getTotalOptionsVoted(results);
  return consulta.options.map((option) => {
    const name = getOptionTitle(option);
    const vots = results.results[name] || 0;
    const percentage = totalOptionsVoted > 0 ? ((vots / totalOptionsVoted) * 100).toFixed(1) : 0;
    return { name, vots, percentage: `${percentage}%`, fill: optionColorMap[name] || OPTION_COLORS[0] };
  });
}

export function getSexChartData(results) {
  if (!results?.by_sex) return [];
  return Object.entries(results.by_sex)
    .map(([sex, data]) => ({ name: sex, total: data.total, ...data.options }))
    .sort((a, b) => b.total - a.total);
}

export function getAgeChartData(results) {
  if (!results?.by_age) return [];
  const orderedData = [];
  AGE_SEGMENTS_ORDER.forEach(segment => {
    if (results.by_age[segment]) {
      orderedData.push({
        name: segment.replace(" anys", ""),
        total: results.by_age[segment].total,
        ...results.by_age[segment].options
      });
    }
  });
  Object.entries(results.by_age).forEach(([segment, data]) => {
    if (!AGE_SEGMENTS_ORDER.includes(segment)) {
      orderedData.push({ name: segment, total: data.total, ...data.options });
    }
  });
  return orderedData;
}
